const stripCodeFences = (text) => {
  if (typeof text !== "string") return "";
  return text
    .replace(/```json\s*/gi, "")
    .replace(/```\s*/g, "")
    .trim();
};

export const extractJsonPayload = (text) => {
  if (!text) return null;
  const start = text.indexOf("{");
  const end = text.lastIndexOf("}");
  if (start === -1 || end === -1 || end <= start) return null;
  return text.slice(start, end + 1);
};

export const tryParseJson = (text) => {
  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch (error) {
    return null;
  }
};

export const repairJsonString = (text) => {
  if (!text) return text;
  let candidate = text.replace(/[“”]/g, "\"").replace(/[‘’]/g, "'");
  const openBraces = (candidate.match(/{/g) || []).length;
  const closeBraces = (candidate.match(/}/g) || []).length;
  const openBrackets = (candidate.match(/\[/g) || []).length;
  const closeBrackets = (candidate.match(/]/g) || []).length;
  if (closeBrackets < openBrackets) {
    candidate += "]".repeat(openBrackets - closeBrackets);
  }
  if (closeBraces < openBraces) {
    candidate += "}".repeat(openBraces - closeBraces);
  }
  return candidate;
};

export const parseJsonFromText = (text) => {
  if (!text) return null;
  const cleaned = stripCodeFences(text);
  let parsed = tryParseJson(cleaned);
  if (parsed) return parsed;

  const extracted = extractJsonPayload(cleaned);
  if (extracted) {
    parsed = tryParseJson(extracted);
    if (parsed) return parsed;
    parsed = tryParseJson(repairJsonString(extracted));
    if (parsed) return parsed;
  }

  return tryParseJson(repairJsonString(cleaned));
};

export const buildJsonRepairPrompt = ({ rawText, schemaHint }) => {
  const schemaLine = schemaHint ? `Schema: ${schemaHint}\n` : "";
  return `Fix the following text into valid JSON only.
${schemaLine}
Return ONLY JSON. Do not add commentary or code fences.

Text to repair:
${rawText || ""}`;
};
